export default __webpack_public_path__ + "static/innos-66aecb754e26d85f778c71270ec57f03.jpg";